const _ = require('lodash');
const toggles = require('./toggles');

class EnvironmentToggles extends toggles.TogglesAPIController {
	constructor(options) {
		// Create toggles if not given.
		options = Object.assign({
			coloured: false, queryKey: 'environment',
			method: 'eventsEnvironmentsList'
		}, options);

		if (!_.has(options, 'toggles')) {
			options.toggles = new toggles.Toggles(null, {hash: _.property('environment')});
		}

		super(options);
	}

	getPaneParams() {
		return {};
	}
}

module.exports = EnvironmentToggles;
